import CustomBadge from "@/components/desktop/badge/CustomBadge";
import styles from "./FormSummary.module.scss";

const FormSummary = ({ items = [], badge = null, variant = "default" }) => {
	if (!items || items.length === 0) return null;

	return (
		<div className={`${styles.summary} ${styles[variant]}`}>
			{badge && (
				<div className={styles.badgeContainer}>
					<CustomBadge variant={badge.variant || "default"}>{badge.text}</CustomBadge>
				</div>
			)}
			<div className={styles.items}>
				{items.map((item, index) => (
					<div key={index} className={styles.item}>
						<span className={styles.label}>{item.label}</span>
						<span className={styles.value}>{item.value || "-"}</span>
					</div>
				))}
			</div>
		</div>
	);
};

export default FormSummary;
